module.exports = __webpack_public_path__ + "static/media/portfolio.3f466fe2.png";